module.exports = __webpack_public_path__ + "static/media/reports_trust.de2cfd9e.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/reports_trust.md
// module id = 1114
// module chunks = 0